import { DashboardYard } from 'src/models/dashboard';

export const DashboardData: DashboardYard[] = [
  {
    id: 1,
    name: 'Yard 1',
    measurements: [
      { id: 1, measurement_name: 'Measurement 1', title: 'Test 1', pressure: 12.3, temperature: 21.5, color: '#f5f8f9' },
      { id: 2, measurement_name: 'Measurement 2', title: 'Test 2', pressure: 13.1, temperature: 20.8, color: '#f5f8f9' },
    ],
  },
];
